export const fetchWithTimeout = async (resource, options = {}) => {
  const { timeout = 10000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    ...options,
    headers: {
      ...options?.headers,
      "X-Csrf-Token": window?.accountDetails?.AuthToken
    },
    signal: controller.signal
  }).finally(() => {
    clearTimeout(id);
  });
  return await response.json();
};
